"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToBackInStockNotification = void 0;
var _fetching = require("@ori/fetching");
const subscribeToBackInStockNotification = exports.subscribeToBackInStockNotification = (0, _fetching.gql)`
  mutation SubscribeToBackInStock($input: BackInStockNotificationSubscriptionInput!) {
    backInStockNotificationSubscription(input: $input)
  }
`;